module.exports = __webpack_public_path__ + "img/size.c77e5b9c.svg";